export const TRIAL10_CODE = "TRIAL10";
export const TRIAL_PRICING_PATH = "/spark-connect#spark-connect-pricing";

export function isUnpaidTrial(status) {
  return Boolean(
    status
    && (status.unpaid_trial || (
      status.status === "trialing"
      && status.has_store
      && !status.has_stripe_subscription
    ))
  );
}

export function isTrialExpired(status) {
  if (!status) return false;
  if (status.can_access) return false;
  return status.status === "trial_expired";
}

export function trialDismissKey(userId) {
  return `ss_trial_modal_dismissed_${userId || "anon"}`;
}
